import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

export function WorkspaceAccess({ children }: { children: ReactNode }) {
  const { isAuthenticated, user } = useAuthStore();
  const { pathname } = useLocation();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (user?.password_change_required && pathname !== '/settings') return <Navigate to="/settings" replace />;
  return <>{children}</>;
}
